import React, { useState, useEffect } from "react";
import { standardTheme, megaTheme, gigaTheme } from "../theme";
import { countStars, capitalizeHeads } from "../../../helpers/stringHelpers";

import styles from "./Details.module.scss";

const Details = ( {battleChip, panelEffects, elements} ) =>
{
    const [ details, setDetails ] = useState([]);
    const [ isLoading, setLoading ] = useState(true);

    useEffect( () => {

        const { name, codes, damage, mb, notes} = battleChip;
        let element = elements.find( element => element.id === battleChip.elementId );
        let panelEffect = panelEffects.find( effect => effect.id === battleChip.panelEffectId );
        let rarity = countStars(battleChip.rarity);

        element = element.imageUrl;
        panelEffect = panelEffect.imageUrl;

        let entries = capitalizeHeads( Object.entries( { name, codes, damage, mb, element, rarity, panelEffect, notes} ) );

        setDetails(entries);

    }, [battleChip] );

    return (
        <div className={styles.root} 
            style={ battleChip.categoryId === 1 ? standardTheme : ( battleChip.categoryId === 2 ? megaTheme : gigaTheme ) }
        >

            <img  className={styles.image} src={battleChip.imageUrl} alt={battleChip.name} disabled={true}></img>
            <table>
                {
                    details.map( (entry) => {
                        return (
                            <tr>
                                <th className={styles.row} >{entry[0]}</th>
                                {
                                    (/(http(s?)):\/\//i.test(entry[1])) ? (<td><img src={entry[1]} alt="N/A" ></img></td>) : (<td>{entry[1]}</td>)
                                }
                            </tr>
                        )
                    })
                }

            </table>
            

        </div>
    )
}

Details.defaultProps = {};

export default Details;